import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { AdaptedModal as Modal } from "components/design-system-adapters/AdaptedModal";
import { withVar } from "themes/helpers";

export const InfoBlock = styled.div`
  p {
    margin-bottom: 1em;
  }

  ul {
    margin: 1em 0;
  }
`;

export const StyledModal = styled(Modal)`
  overflow: auto;
  .lc-modal__body {
    background: ${withVar(DesignToken.SurfacePrimaryDefault)};
    border-top: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
    border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  }
`;

export const customDomainCss = css``;

export const linkStyles = css`
  text-decoration: none;
  color: ${withVar(DesignToken.ActionPrimaryDefault)};
  &:hover {
    text-decoration: underline;
  }
`;

export const ModalBlock = styled.div`
  font-size: 14px;

  @media (max-width: 400px) {
    font-size: 14px;
  }

  dl {
    margin-bottom: 16px;
  }

  dt {
    padding-bottom: 4px;
  }

  dd {
    font-weight: 700;
  }
`;

export const CustomDomainHelpParagraph = styled.p`
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  margin-top: 16px;
`;
